import { authStorage } from "../utils/storage";

export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_URL || "https://api.air1bet.com",
  SOCKET_URL: process.env.REACT_APP_SOCKET_URL || "wss://api.air1bet.com",
  SITE_URL: process.env.REACT_APP_SITE_URL || "https://stakebet.games",
  SITE_NAME: process.env.REACT_APP_SITE_NAME || "Air1Bet",
};

async function apiFetch(path, options = {}) {
  const token = authStorage.getToken();
  const isAbsolute = path.startsWith("http");
  const url = isAbsolute ? path : `${API_CONFIG.BASE_URL}${path}`;

  const headers = { "Content-Type": "application/json", ...(options.headers || {}) };
  if (token && !path.includes("/auth/login")) headers["Authorization"] = `Bearer ${token}`;

  const response = await fetch(url, { ...options, headers });

  if (response.status === 401) {
    authStorage.removeToken();
    authStorage.setLoggedIn(false);
    window.location.href = "/login";
    throw new Error("Unauthorized");
  }
  if (response.status === 204) return {};
  if (!response.ok) throw new Error((await response.text()) || `HTTP ${response.status}`);
  return response.json();
}

const api = {
  get: (path) => apiFetch(path),
  post: (path, body) => apiFetch(path, { method: "POST", body: JSON.stringify(body) }),
  put: (path, body) => apiFetch(path, { method: "PUT", body: JSON.stringify(body) }),
  delete: (path) => apiFetch(path, { method: "DELETE" }),
  patch: (path, body) => apiFetch(path, { method: "PATCH", body: JSON.stringify(body) }),
};

export default api;
